var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallEllipsisDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 6,
    cy: 15.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 15,
    cy: 15.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 24,
    cy: 15.5,
    r: 2.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallEllipsisDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-ellipsis-default.40325ac6379c29c6f16289401a48fe7c.svg";